<template>
  <div>
    <v-dialog v-model="dialogOpenNoSnack" persistent max-width="1400">
      <v-card>
        <v-card-title>Change Tariff</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="7">

              <v-stepper v-model="currentStep" vertical>
                <v-stepper-step :complete="currentStep > 1" :editable="currentStep > 1" step="1" >Select Change Reason</v-stepper-step>
                <v-stepper-content step="1">
                  <v-row>
                    <v-col cols="6">
                      <v-select v-model="form.changeReason" label="Select change reason" @change="changeChangeReason" :items="changeReasonsEdited" outlined dense hide-details>
                        <template #item="{ item, on, attrs }">
                          <v-list-item v-bind="attrs" v-on="(!item.permissions||hasUserGotRoles(item.permissions)) && on">
                            <template v-if="!item.permissions">
                              {{ item.text }}
                            </template>

                            <template v-else>
                              <template v-if="hasUserGotRoles(item.permissions)">
                                {{ item.text }}
                              </template>

                              <v-tooltip v-else bottom>
                                <template v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }">
                                  <div class="flex grey--text" v-bind="attrsTooltip" v-on="onTooltip">
                                    <span>{{ item.text }}</span>
                                  </div>
                                </template>

                                <span>{{ item.tooltip.permission }}</span>
                              </v-tooltip>
                            </template>
                          </v-list-item>
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-divider></v-divider>
                      <v-btn color="primary" small @click="startForm" :disabled="form.changeReason===''||startFormLoading" :loading="startFormLoading">Continue</v-btn>
                    </v-col>
                  </v-row>
                </v-stepper-content>
                
                <template v-if="form.changeReason===''">
                  <v-stepper-step step="2">Next Steps</v-stepper-step>
                  <v-stepper-content step="2"></v-stepper-content>
                </template>
                <template v-if="form.changeReason==='CHANGE_ADD_ONS'">
                  <SiteAddons :currentStep="currentStep" :isStep="2" @continue="currentStep++;" :addons="form.siteAddons"/>
                  <UserAddons :currentStep="currentStep" :isStep="3" @continue="currentStep++;" :users="form.users" :userAddons="userAddons"/>
                </template>
                <template v-if="selectedChangeReason">
                  <Tariff :currentStep="currentStep" :isStep="2" @continue="currentStep++;" :formData="form" :siteInitial="siteInitial"/>
                  <SiteAddons :currentStep="currentStep" :isStep="3" @continue="currentStep++;" :addons="form.siteAddons"/>
                  <UserAddons :currentStep="currentStep" :isStep="4" @continue="currentStep++;" :users="form.users" :userAddons="userAddons"/>
                  <AdhocCharges :currentStep="currentStep" :isStep="5" @continue="currentStep++;" :adhoc="mapRequiredCharges"/>
                </template>

                <v-stepper-step :complete="currentStep > confirmStep" :step="confirmStep">Confirm Changes</v-stepper-step>
                <v-stepper-content :step="confirmStep">
                  <v-row>
                    <v-col>
                      <p>Please make sure all information on the right is correct.</p>
                      <template v-if="selectedChangeReason">
                        <p>New contract start date will be created: <b>{{todaysDate()}}</b></p>
                      </template>
                      <template v-if="mapRequiredCharges.length">
                        <div class="font-weight-bold mb-4">
                          An ad hoc invoice of {{ calculateRequiredCharges | formatCurrency}} + VAT will be sent to {{ getCurrentAccount.email_address }}
                        </div>
                      </template>
                      <v-checkbox v-model="contentConsent" label="I confirm I have checked all the changes"></v-checkbox>
                    </v-col>
                  </v-row>
                </v-stepper-content>
              </v-stepper>

            </v-col>
            <v-col cols="5">
              <template v-if="form.changeReason!==''&&currentStep!==1">
                <ChangedDataView :formData="form" :currentStep="currentStep" :userAddons="userAddons" :unavailable="getUnavailableAddons" :adhoc="mapRequiredCharges"/>
                <Totals :formData="form" :currentStep="currentStep" :adhoc="mapRequiredCharges"/>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" small @click="sendChangeTariff" :loading="changeTariffLoading" :disabled="!contentConsent||changeTariffLoading">Change Tariff</v-btn>
          <v-btn color="primary" small outlined class="ml-3" @click="closeDialog">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="changeTariffSnack.show" :timeout="-1 ">
      <span :class="`${snackColors[changeTariffSnack.type]}--text`">{{ changeTariffSnack.text }}</span>
      <template v-slot:action="{ attrs }">
        <v-btn :color="snackColors[changeTariffSnack.type]" text v-bind="attrs" @click="closeSnack"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  import { mapState,mapActions,mapMutations, mapGetters } from "vuex";
  import productHelper from '@/helpers/product';
  import Tariff from "./ChangeTariffSteps/Tariff";
  import SiteAddons from "./ChangeTariffSteps/SiteAddons";
  import UserAddons from "./ChangeTariffSteps/UserAddons";
  import AdhocCharges from "./ChangeTariffSteps/AdhocCharges";
  import ChangedDataView from "./ChangeTariffSteps/ChangedDataView";
  import Totals from "./ChangeTariffSteps/Totals";
  import moment from "moment";

  import TariffJS from './../../mixins/ChangeTariffTariffs.js';

  export default {
    data() { 
      return {
        contentConsent: false,
        currentStep: 1,
        confirmStep: 3,
        changeReasons: [
          {text:'Change Add Ons',value:'CHANGE_ADD_ONS'},
          { text:'Contract Renewal', 
            value:'RENEWAL', 
            permissions: ['can-do-contract-renewals'], 
            tooltip: { 
              permission: 'You do not have permission to use the Contract Renewals change reason' 
            }
          },
          { 
            text:'Retention', 
            value:'RETENTION', 
            permissions: ['can-use-retention-change-tariff'],
            tooltip: { 
              permission: 'You do not have permission to use the Retention change reason' 
            }
          },
          {text:'Change Product',value:'CHANGE_PRODUCT'},
          {text:'Pre-live', value: 'PRE_LIVE'},
        ],
        form: {
          changeReason: '',
          iniTariff: {id:'',name:'',price:0},
          tariff: {id:'',name:'',price:0,required_charges:[],included_child_charges: []},
          iniCLength: '',
          cLength: '',
          iniPromo: {id:'',name:'',price:0},
          promo: {id:'',name:'',price:0},
          siteAddons: {},
          users: []
        },
        startFormLoading: false,
        userAddons: {},
        siteAddons: {},
        userAddonsUnavailable: {},
        siteAddonsUnavailable: {},
        allPromos: {},
        allTariffs: {},
        snackColors: {success:'secondary',error:'error',info:'primary'},
      }
    },
    mixins: [TariffJS],
    computed: {
      ...mapState("products", ["productAddons","voipSiteAddons","changeTariffLoading","changeTariffSnack","productAllTariffs","productAllPromos","selectedTariffPromos"]),
      ...mapGetters('products', ['getCurrentProduct']),
      ...mapGetters("globals", ["hasUserGotRoles"]),
      ...mapGetters('accounts',['getCurrentAccount']),

      dialogOpenNoSnack(){ return this.dialogOpen && !this.changeTariffSnack.show; },

      changeReasonsEdited() {
        return this.changeReasons.filter(reason => this.getCurrentProduct.confirmed_date ? reason.value !== 'PRE_LIVE' : reason.value === 'PRE_LIVE');
      },

      selectedChangeReason() {
        return this.form.changeReason === 'RENEWAL' || this.form.changeReason === 'RETENTION' || this.form.changeReason === 'PRE_LIVE'|| this.form.changeReason === 'CHANGE_PRODUCT';
      },
      getUnavailableAddons() {
        const addons = { siteAddons: {}, userAddons: {} };
        let selectedSiteAddons = {};
        this.siteInitial.addons.forEach(add => { selectedSiteAddons[add.addon_id] = add; });
        this.voipSiteAddons.forEach(add => {
          let selAdd = selectedSiteAddons[add.id];
          if(!add.available && selAdd){
            this.$set(addons.siteAddons, add.id, add);
          }
        });

        this.productChildren.reduce((acc, item) => {
          if (productHelper.isActive(item)) {
            this.$set(addons.userAddons, item.id, []);
            item.addons.forEach(userAddon => {
              this.productAddons.forEach(add => {
                if(userAddon.addon_id === add.id && !add.available) {
                  addons.userAddons[item.id].push(add);
                }
              });
            });
          }
          return acc;
        }, []);

        return addons;
      },
      getInitialRequiredCharges() {
        const promo = this.getPromoById(this.siteInitial.promo.id);
        const tariff = this.findTariffById(this.siteInitial.tariff.id);
        if(promo && promo.required_charges.length) {
          return promo.required_charges;
        }
        return tariff.required_charges;
      },
      mapRequiredCharges() {
        const charges = this.form.tariff.required_charges || [];
        const childCharges = this.form.tariff.included_child_charges || [];

        const mergeCharges = [
          ...charges.map(e => ({ ...e, quantity: 1 })), 
          ...childCharges.map(e => ({ ...e, quantity: this.form.users.length })),
        ];

        return mergeCharges.map(e => ({
          id: e.id,
          name: e.name,
          price: e.standard_price,
          checked: true,
          quantity: e.quantity,
          category: e.category,
        }));
      },
      calculateRequiredCharges() {
        let total = 0;
        this.mapRequiredCharges.forEach(e => {
          total += e.price * e.quantity;
        });
        return total;
      },
    },
    props: ['productID','dialogOpen','siteInitial','productChildren'],
    components: { ChangedDataView,Tariff,SiteAddons,UserAddons,AdhocCharges,Totals },
    methods: {
      ...mapActions("products", ["changeTariff"]),
      ...mapMutations("products", ["setChangeTariffSnack","setChangeTariffLoading"]),

      resetForm() {
        this.contentConsent = false;
        this.currentStep = 1;
        this.confirmStep = 3;
        this.form = {
          changeReason: '',
          iniTariff: {id:'',name:'',price:0},
          tariff: {id:'',name:'',price:0},
          iniCLength: '',
          cLength: '',
          iniPromo: {id:'',name:'',price:0},
          promo: {id:'',name:'',price:0},
          siteAddons: {},
          users: []
        };
       
        this.startFormLoading = false;
        this.userAddons = {};
        this.siteAddons = {};
        this.allPromos = {};
        this.allTariffs = {};       
      },

      closeDialog() {
        this.resetForm();
        this.$emit('close-dialog');
      },

      closeSnack(){
        if(this.changeTariffSnack.type!=='error'){ this.$emit('close-dialog'); }
        this.setChangeTariffLoading(false);
        this.setChangeTariffSnack({show:false,text:'',type:''});
      },
      todaysDate(){
        return moment().format('YYYY-MM-DD');
      },
      async startForm(){
        this.startFormLoading = true;
        await this.sortTariffs();
        
        this.form.tariff = this.siteInitial.tariff;
        this.form.cLength = this.siteInitial.cLength;
        this.form.promo = this.siteInitial.promo;
        this.form.tariff.included_child_charges = this.siteInitial.tariff.included_child_charges;
        this.form.tariff.required_charges = this.getInitialRequiredCharges;

        this.form.iniTariff = this.form.tariff;
        this.form.iniCLength = this.form.cLength;
        this.form.iniPromo = this.form.promo;


        await this.sortSiteAddons();
        await this.sortUsers();

        this.currentStep = 2;
        this.startFormLoading = false;
      },
      async sortSiteAddons(){
        let selectedSiteAddons = {};
        this.siteInitial.addons.forEach(add => { selectedSiteAddons[add.addon_id] = add; });
        this.voipSiteAddons.forEach(add => {
          let selAdd = selectedSiteAddons[add.id];
          if(add.available){
            this.$set(this.form.siteAddons, add.id, {
              name: add.name,
              allow_quantity: add.allow_quantity,
              price: parseFloat(add.standard_price),
              id: add.id,
              quantity: (selAdd!==undefined)?selAdd.quantity:0,
              selected: (selAdd!==undefined)?true:false,
              iniQuantity: (selAdd!==undefined)?selAdd.quantity:0,
              iniSelected: (selAdd!==undefined)?true:false,
            });
          }
        });
      },
      async sortUsers(){
        this.$set(this.form, 'users', this.productChildren.reduce((acc, item) => {
          if (productHelper.isActive(item)) {
            acc.push({
              id: item.id,
              ext: item.product_details.extension,
              number: item.product_details.number,
              addons: this.sortUserAddons(item.addons),
            });
          }
          return acc;
        }, []));
      },
      sortUserAddons(addons){
        let selectedAddons = [];
        let groupedAddons = {};
        this.productAddons.forEach(add => {
          if(add.available){
            if(add.display_group!==undefined&&add.display_group!==''&&add.display_group!==null){
              if(groupedAddons[add.display_group]===undefined){ groupedAddons[add.display_group] = {
                count: 0,
                items: [],
                name: this.titleCase(add.display_group.replace(/_/g,' ')),
                iniSelected: false,
                selected: false,
                iniPrice: 0,
                price: 0,
              }; }
              groupedAddons[add.display_group].count++;
            }else{
              groupedAddons['no_group'] = {
                count: 0,
                items: [],
                name: '',
                iniSelected: false,
                selected: false,
                iniPrice: 0,
                price: 0,
              };
            }
            this.$set(this.userAddons, add.id, {
              name: add.name,
              iniPrice: parseFloat(add.standard_price),
              price: parseFloat(add.standard_price),
              id: add.id,
            });
          }
        });
        addons.forEach(add => { selectedAddons.push(add.addon_id); });
        this.productAddons.forEach(add => {
          if(add.available){
            let group_name = (add.display_group!==undefined&&add.display_group!==''&&add.display_group!==null)?add.display_group:'no_group';
            // group_name = (groupedAddons[group_name].count>1)?group_name:'no_group';
            groupedAddons[group_name].items.push({
              id: add.id,
              name: add.name,
              iniPrice: parseFloat(add.standard_price),
              price: parseFloat(add.standard_price),
              selected: selectedAddons.includes(add.id),
              iniSelected: selectedAddons.includes(add.id),
              rank: add.group_rank,
              disabled: false,
            });
          }
        });
        
        Object.keys(groupedAddons).forEach(k => {
          let group = groupedAddons[k];
          if(group.count>1){
            group.items.sort(function(a,b){return a['rank']-b['rank']});
          }
        });

        let groups = [];
        this.form.tariff.addons.forEach(add => {
          if(add.display_group!==undefined&&add.display_group!==null&&add.display_group!==''){
            groups.push(add.display_group);
            let group = groupedAddons[add.display_group];
            let items = group.items;
            let addId = add.id;
            let isDisabled = false;
            items.forEach(item => {
              item.disabled = !(item.id===addId||isDisabled);
              if(item.id===addId){ isDisabled = true; }
            });
            items.reverse();
          }
        });
        Object.keys(groupedAddons).forEach(k => {
          if(k !== 'no_group') {
            let group = groupedAddons[k];
            group.items.push({name:'None',price:0,id:null,disabled:false});
            let selected = false;
            group.items.forEach(item => {
              if(!selected&&item.selected){
                selected = true;
                group.iniSelected = item.id;
                group.selected = item.id;
                group.price = parseFloat(item.price);
                group.iniPrice = parseFloat(item.iniPrice);
              }else if(selected){
                item.iniSelected = false;
                item.selected = false;
              }
            });
          }
        });
        return groupedAddons;
      },
      titleCase(str) {
        if(str===''){ return ''; }
        return str.toLowerCase().split(' ').map(function(word) {
          return word.replace(word[0], word[0].toUpperCase());
        }).join(' ');
      },
      changeChangeReason(){
        this.confirmStep = 4;
        if (this.form.changeReason === 'RENEWAL' || this.form.changeReason === 'RETENTION' || this.form.changeReason === 'PRE_LIVE' || this.form.changeReason === 'CHANGE_PRODUCT'){
          this.confirmStep = 6;
        }
      },
      sortAddonsToSend(addons,forUsers){
        let retAddons = [];
        Object.keys(addons).forEach(ad_key => {
          let add = addons[ad_key];
          if(add.allow_quantity&&!forUsers){
            if(add.quantity>0){
              retAddons.push({addon_id:(forUsers)?add.id:ad_key,quantity:add.quantity});
            }
          }else{
            if(add.selected){
              retAddons.push({addon_id:(forUsers)?add.id:ad_key,quantity:1});
            }
          }
        });
        return retAddons;
      },
      sortUserAddonsToSend(groups){
        let retAdds = [];
        Object.keys(groups).forEach(k => {
          let group = groups[k];
          if(k !== 'no_group') {
            if(group.selected){
              retAdds.push({addon_id:group.selected,quantity:1});
            }
          } else {
            group.items.forEach(item => {
              if(item.selected){
                retAdds.push({addon_id:item.id,quantity:1});
              }
            });
          }
        });
        return retAdds;
      },
      sortUsersToSend(users){
        let retUsers = [];
        users.forEach(user => {
          retUsers.push({
            id: user.id,
            addons: this.sortUserAddonsToSend(user.addons)
          });
        });
        return retUsers;
      },
      sortAdhocChargesToSend(requiredCharges) {
        return requiredCharges.map(e => ({
          charge_credit_id: e.id,
          quantity: e.quantity,
        }));
      },
      async sendChangeTariff() {
        let fm = this.form;
        let payload = {};
        switch(this.form.changeReason){
          case 'CHANGE_ADD_ONS':
            payload = {
              change_reason: "CHANGE_ADDON",
              product: {
                id: this.productID,
                addons: this.sortAddonsToSend(fm.siteAddons,false)
              },
              children: this.sortUsersToSend(fm.users)
            }
          break;
          case 'RENEWAL':
            payload = {
              change_reason: "CONTRACT_RENEWALS",
              product: {
                id: this.productID,
                tariff_id: fm.tariff.id,
                promo_id: fm.promo.id ? fm.promo.id : null,
                contract_length_months: fm.cLength,
                addons: this.sortAddonsToSend(fm.siteAddons,false)
              },
              children: this.sortUsersToSend(fm.users)
            }
          break;
          case 'CHANGE_PRODUCT':
            payload = {
              change_reason: "CHANGE_PRODUCT",
              product: {
                id: this.productID,
                tariff_id: fm.tariff.id,
                promo_id: fm.promo.id ? fm.promo.id : null,
                contract_length_months: fm.cLength,
                addons: this.sortAddonsToSend(fm.siteAddons,false),
              },
              adhoc_charges: this.sortAdhocChargesToSend(this.mapRequiredCharges),
              children: this.sortUsersToSend(fm.users)
            }
          break;
          case 'RETENTION':
            payload = {
              change_reason: "RETENTION",
              product: {
                id: this.productID,
                tariff_id: fm.tariff.id,
                promo_id: fm.promo.id ? fm.promo.id : null,
                contract_length_months: fm.cLength,
                addons: this.sortAddonsToSend(fm.siteAddons,false)
              },
              children: this.sortUsersToSend(fm.users)
            }
          break;
          case 'PRE_LIVE':
            payload = {
              change_reason: "PRE_LIVE",
              product: {
                id: this.productID,
                tariff_id: fm.tariff.id,
                promo_id: fm.promo.id ? fm.promo.id : null,
                contract_length_months: fm.cLength,
                addons: this.sortAddonsToSend(fm.siteAddons,false)
              },
              children: this.sortUsersToSend(fm.users)
            }
          break;
        }
        let success = await this.changeTariff({id:this.productID,payload:payload});
        if(success){
          this.$emit('changeTariffSuccess',{data:fm});
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .v-application--is-ltr .theme--light.v-stepper--vertical {
    .v-stepper__content {
      width: calc(100% - 40px) !important;
      &:not(:last-child) {
        border: none !important;
      }
    }
    .v-stepper__step {
      padding: 15px;
      margin: 10px;
    }
  }
  .v-stepper__wrapper { padding: 2px !important; }
</style>
